export default __webpack_public_path__ + "static/media/untagging_transactions.2b60312a.png";